var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingStatusCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 14.6668C11.6825 14.6668 14.6673 11.6821 14.6673 8.00016C14.6673 4.31826 11.6825 1.3335 8.00065 1.3335C4.31875 1.3335 1.33398 4.31826 1.33398 8.00016C1.33398 11.6821 4.31875 14.6668 8.00065 14.6668ZM11.0899 6.92275C11.4153 6.59731 11.4153 6.06968 11.0899 5.74424C10.7645 5.4188 10.2368 5.4188 9.9114 5.74424L7.16732 8.48832L6.08991 7.41091C5.76447 7.08547 5.23683 7.08547 4.9114 7.41091C4.58596 7.73634 4.58596 8.26398 4.9114 8.58942L6.57806 10.2561C6.9035 10.5815 7.43114 10.5815 7.75657 10.2561L11.0899 6.92275Z",
    fill: "#3A836C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingStatusCheck);
export default __webpack_public_path__ + "static/media/onboarding-status-check.a6a04e30b2c4d01ddab308e10b0fdc4d.svg";
export { ForwardRef as ReactComponent };